export default __webpack_public_path__ + "static/media/ongoing4.cf62fa3c.png";